<template>
	<div>
		<div class="d-sm-flex">
			<span class="grey--text pl-1 pt-2">انتخاب مخاطب:</span>
			<v-select outlined v-model="selectedTargetType" single-line item-text="title" item-value="value" style="max-width:300px" :items="targetTypes" dense></v-select>
			<div v-if="selectedTargetType === 3" class="d-flex">
				<v-btn color="secondary" class="mt-2 mx-1" small text @click="() => { dialogMembersSelector = true }">
					انتخاب مشتریان
				</v-btn>
				<v-chip color="warning" class="mt-2" small>تعداد انتخاب شده: {{ selectedMemberIds.length }}</v-chip>
			</div>
			<div v-if="selectedTargetType === 5" class="d-flex">
				<v-btn color="secondary" class="mt-2 mx-1" small text @click="() => { dialogAgentsSelector = true }">
					انتخاب نماینده ها
				</v-btn>
				<v-chip color="warning" class="mt-2" small>تعداد انتخاب شده: {{ selectedAgentIds.length }}</v-chip>
			</div>
		</div>

		<v-dialog v-model="dialogMembersSelector" scrollable max-width="900px">
			<MembersSelector v-if="dialogMembersSelector" :selectedIds="selectedMemberIds" @select="onMembersSelectorSelect" @close="dialogMembersSelector = false" />
		</v-dialog>

		<v-dialog v-model="dialogAgentsSelector" scrollable max-width="900px">
			<AgentsSelector v-if="dialogAgentsSelector" :selectedIds="selectedAgentIds" @select="onAgentsSelectorSelect" @close="dialogAgentsSelector = false" />
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { commit, get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'TicketUsersSelector',
		props: {
			ticketId: { type: String },
			userType: { type: String }
		},
		components: {
			...get('siteConfig', [
				'isCloud'
			]),
			ConfirmDlg: () => import('@/components/Confirm'),
			AgentsSelector: () => import('@/components/forms/AgentsSelector'),
			MembersSelector: () => import('@/components/forms/MembersSelector'),
		},
		data() {
			return {
				dialogMembersSelector: false,
				dialogAgentsSelector: false,
				emptyId: emptyId,
				selectedTargetType: null,
				selectedAgentIds: [],
				selectedMemberIds: [],
				targetTypes: [
					{ title: 'همه مشتریان', value: 1 },
					{ title: 'مشتریان دارای پرونده فعال', value: 2 },
					{ title: 'مشتریان انتخاب شده', value: 3 },
					{ title: 'همه نماینده ها', value: 4 },
					{ title: 'نماینده های انتخاب شده', value: 5 },
				],
			}
		},
		computed: {

		},
		mounted() {
			if (this.isCloud)
				this.targetTypes.push({ title: 'پشتیبان سرویس ابری', value: 5 })
		},
		methods: {
			loadData() {
				this.loading = true
				api.get(`${this.userType}/Ticket/Get/` + this.ticketId, null)
					.then(response => {
						this.localData = response
					})
					.catch(err => {
						this.localData = null
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			onAgentsSelectorSelect(agentIds) {
				this.selectedAgentIds = agentIds
			},
			onMembersSelectorSelect(memberIds) {
				this.selectedMemberIds = memberIds
			},
			commitData() {
				return {
					targetType: this.selectedTargetType,
					userIds: this.selectedTargetType === 3 ? this.selectedMemberIds : (this.selectedTargetType === 5 ? this.selectedAgentIds : [])
				}
			}
		},
	}
</script>
<style></style>
